import {aesDecrypt} from '@/utils/aesCrypto'
import { appStorage, tokenStorage, userStorage } from './storage'

/**
 * 解密 common 参数
 * APP 端流程：JSON.encode -> AES.encrypt -> Uri.encodeComponent
 * H5 端流程：decodeURIComponent -> AES.decrypt -> JSON.parse
 */
export const decryptCommonParam = () => {
  try {
    // 从 URL 手动提取原始值
    const search = window.location.search
    const match = search.match(/[?&]common=([^&]+)/)
    
    if (!match || !match[1]) {
      // console.log('No common parameter found')
      return null
    }

    const rawValue = match[1]

    const newValue = decodeURIComponent(rawValue)
    
    
    // 尝试多种解码方式
    return aesDecrypt(newValue)
  } catch (error) {
    console.error('❌ Decryption failed:', error)
    return null
  }
}

/**
 * 从 URL 获取参数
 */
export const getAppLoginParams = () => {
  const params = new URLSearchParams(window.location.search)
  return {
    appId: params.get('appId'),
    hasCommon: !!params.get('common')
  }
}

/**
 * 执行 APP 登录
 */
export const performAppLogin = async () => {
  try {
    const { appId, hasCommon } = getAppLoginParams()
    
    if (!appId || !hasCommon) {
      return false
    }

    console.log('Starting APP login, appId:', appId)
    
    // 解密获取 token
    const data = decryptCommonParam()
    
    if (!data?.token) {
      console.error('No token in decrypted data')
      return false
    }

    // 保存
    appStorage.setAppId(appId)
    tokenStorage.setToken(data.token)
    userStorage.setTouristLoginFlag(true)
    
    console.log('✅ APP login successful')
    return true
  } catch (error) {
    console.error('APP login failed:', error)
    return false
  }
}

/**
 * 清除 URL 参数
 */
export const clearAppLoginParams = () => {
  const url = new URL(window.location.href)
  url.searchParams.delete('appId')
  url.searchParams.delete('common')
  window.history.replaceState({}, '', url.toString())
}

/**
 * 检查是否有 APP 登录参数
 */
export const hasAppLoginParams = () => {
  const { appId, hasCommon } = getAppLoginParams()
  return !!(appId && hasCommon)
}
